import AgreementFieldsPreview from './AgreementFieldsPreview.component';

export default AgreementFieldsPreview;
